import { useT } from "@transifex/react"

export const FailedScreen = ({
  message,
  gympassToken,
  fitnessOnDemandToken,
  promoLinkToken,
  onTryAgain,
}: {
  message: string | undefined
  gympassToken: string | undefined
  fitnessOnDemandToken: string | undefined
  promoLinkToken: string | undefined
  onTryAgain: () => void
}) => {
  const t = useT()
  let friendlyMessage
  let allowRetry = true
  switch (message) {
    case "no_such_promo_code":
      friendlyMessage = t("The promo code you entered does not exist.")
      break
    case "not_valid_yet":
      friendlyMessage = t("The promo code you entered is not valid yet.")
      break
    case "expired":
      friendlyMessage = t("The promo code you entered has expired.")
      break
    case "already_redeemed":
      friendlyMessage = t(
        "We couldn't redeem the promo code because you already redeemed it before.",
      )
      break
    case "token_expired":
      if (gympassToken) {
        friendlyMessage = t(
          "The Wellhub activation token has expired. Please start over.",
        )
      } else if (fitnessOnDemandToken) {
        friendlyMessage = t(
          "The Fitness On Demand account linking token has expired. Please start over.",
        )
      } else {
        friendlyMessage = t("A technical token has expired. Please start over.")
      }
      allowRetry = false
      break
    case "token_not_found":
      if (gympassToken) {
        friendlyMessage = t(
          "The Wellhub activation token is invalid. Please start over.",
        )
      } else if (fitnessOnDemandToken) {
        friendlyMessage = t(
          "The Fitness On Demand account linking token is invalid. Please start over.",
        )
      } else {
        friendlyMessage = t("A technical token is invalid. Please start over.")
      }
      allowRetry = false
      break
    case "already_has_premium":
      friendlyMessage = gympassToken
        ? t(
            "We couldn't activate Wellhub because you already have a Motosumo Premium subscription.",
          )
        : t(
            "We couldn't redeem the promo code because you already have a Motosumo Premium subscription.",
          )
      allowRetry = false
      break
    case "already_has_gympass":
      friendlyMessage = t(
        "We couldn't redeem the promo code because you already have Motosumo Premium through Gympass.",
      )
      allowRetry = false
      break
    default:
      friendlyMessage = (
        <>
          {t("Something went wrong. Please contact support at {email}.", {
            email: <a href="support@motosumo.com">support@motosumo.com</a>,
          })}
        </>
      )
  }
  return (
    <>
      <div className="error-circle">
        <div className="error" />
      </div>
      <p className="App-title">{t("Failed")}</p>
      <p className="App-description">{friendlyMessage}</p>
      {allowRetry && (
        <input
          className="App-button"
          type="button"
          value={t("Try again")}
          onClick={onTryAgain}
        />
      )}
    </>
  )
}
